'use strict';
module.exports = function isEmpty(obj) {
	if (Number.isFinite(obj)) {
		return false;
	}
	if (!obj) return true;

	if (Array.isArray(obj) || typeof obj === 'number') {
		return obj.length === 0;
	}
	return Object.keys(obj).length === 0;
};
